import React from "react";
import StyledCleave from "./StyledCleaveInput";

export default function ZipCodeInput(props: any) {
  return (
    <StyledCleave
      {...props}
      center
      options={{ numericOnly: true, blocks: [5] }}
    />
  );
}
